<template>
  <el-config-provider :locale="locale">
    <template v-if="!route.meta.isComposition">
      <router-view v-if="route.path.includes('pptH5')" />
      <div id="box" v-else-if="isShowPro">
        <div class="left"
        v-if="!route.path.includes('pay') &&
        !route.path.includes('createPPT') &&
        !route.path.includes('outlinePPT') && 
        !route.path.includes('pptIframe') && 
        !route.path.includes('type4PPT') && 
        !route.path.includes('aniDetail') && showMenu" ><Menu></Menu></div>
        <div class="right">
          <router-view :key="route.fullPath" />
        </div>
      </div>
    </template>
    <template v-else>
      <div id="box1">
        <div class="left" v-show="!route.meta.isLeft"><menuComposition></menuComposition></div>
        <div class="right">
          <Header v-if="!route.meta.noHeader"></Header>
          <router-view />
        </div>
      </div>
    </template>
    <Login v-if="showLogin"></Login>
    <Register v-if="showRegister"></Register>
    <ForgetPassword v-if="showForget"></ForgetPassword>
    <ShowMember ></ShowMember>
  </el-config-provider>
</template>
<script setup>
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
const locale = zhCn;
import { ElMessageBox } from 'element-plus';
import { jumpLogin, getByUserId } from '@/api/index';
import { ref, watch } from 'vue';
import Menu from '@/components/menu/index.vue';
import menuComposition from '@/components/menu/indexComposition.vue';
import Login from '@/components/login/login.vue'
import Register from '@/components/login/register.vue'
import ForgetPassword from '@/components/login/forgetPassword.vue'
import ShowMember from '@/components/showMember.vue'
import Header from '@/components/header.vue';
import {useRoute} from 'vue-router';
import { mittBus } from "@/utils/bus";
const route = useRoute();
import useHomeStore from '@/store/home'
const homeStore = useHomeStore()
import { storeToRefs } from 'pinia'
const { showLogin, showRegister, showForget } = storeToRefs(homeStore)
const isShowPro = ref(false);



const showMenu = ref(true);
watch(route, () => {
  if(!route.path.includes('designChat')) {
    showMenu.value = true;
  } 
});

mittBus.on("showMenu", (val) => {
  showMenu.value = val;
});

// 获取token
const jumpLoginM = (info) => {
  jumpLogin({info}).then(res => {
    if (res.code == 200) {
      localStorage.setItem('intelligenceInfo', JSON.stringify(res.data));
      // 登录成功后清除infoFromRoute标记
      localStorage.removeItem('infoFromRoute');
      getByUserIdM(res.data.id)
      mittBus.emit('loginSuccess', res.data);
    } else {
      Object.keys(localStorage).forEach(key => {
        if (key !== 'info') {
          localStorage.removeItem(key);
        }
      });
      // ElMessageBox.alert('登录信息出现错误请您前往登录', '警告', {
      //   confirmButtonText: '确定',
      //   type: 'warning',
      //   callback: () => {
      //     window.close();
      //   }
      // });
    };
  });
};

const getByUserIdM = async (id) => {
  const res = await getByUserId({
    userId:id
  })
  if(res.code == 200) {
    let editInfo =  JSON.parse(localStorage.getItem('intelligenceInfo'))
    editInfo.nikeName = res.data.nickName
    // editInfo.url = res.data.url
    localStorage.setItem('intelligenceInfo',JSON.stringify(editInfo))
  }
}


//h5
const token = ref()
const mobile_mobileType = ref()
const getParams = () => {
 // 获取完整的URL
  const url = new URL(window.location.href);
  // 提取#后的查询字符串（包括"?"）
  const hashQuery = url.hash.split('?')[1]; // 得到 "token=1&mobileType=2"
  const params = new URLSearchParams(hashQuery);
  // 获取具体参数值
  token.value = params.get('authorization'); 
  mobile_mobileType.value = params.get('mobile_mobileType');
 
}
getParams()

watch(route, () =>{
  let info = '';
  if (route.query.info) {
    localStorage.setItem('info', route.query.info);
    // 标记info来自路由
    localStorage.setItem('infoFromRoute', 'true');
    info = route.query.info;
  } else {
    info = localStorage.getItem('info');
    // 清除标记
    localStorage.removeItem('infoFromRoute');
  };
  if (info) {
    jumpLoginM(info);
  };
  //h5
  if(token.value) {
    localStorage.setItem('intelligenceInfo', JSON.stringify({
      token: token.value
    }));
  }
  setTimeout(() => {
    isShowPro.value = true
  }, 500);
},{
  immediate: true
});

</script>
<style lang="scss">
* {
  margin: 0px;
}
html,body,#app,#box {
  width: 100%;
  height: 100vh;
  background-image: #FFFFFF;
}
#box {
  display: flex;
  .left {
    width: 260px;
  }
  .right {
    flex: 1;
  }
}
#box1 {
  width: 100%;
  height: 100vh;
  background-image: linear-gradient(122deg, #fbf5fb 0%, #dcebfd 100%);
  display: flex;
  .left {
    width: 260px;
  }
  .right {
    flex: 1;
  }
}
::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}
::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
  display: none;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  border: 4px solid rgba(0, 0, 0, 0);
  height: 6px;
  border-radius: 25px;
  background-clip: padding-box;
  background-color: rgba(0, 0, 0, 0.3);
}



/* 禁用浏览器默认的 user agent 样式（可能是隐藏冲突源） */
.el-tooltip__trigger {
  &:hover,
  &:focus {
    outline: none;
    border: none;
  }
}
</style>
